exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".snackbar[data-v-2d0c42ab]{font-size:20px}", ""]);

// exports
